import { useEffect } from 'react';

declare global {
  interface Window {
    plausible: ((...args: unknown[]) => void) & {
      q?: unknown[];
      o?: Record<string, unknown>;
      init?: (opts?: Record<string, unknown>) => void;
    };
  }
}

let injected = false;

/**
 * Injects the Plausible Analytics script on public-facing pages.
 * Safe to call from multiple components — the script is only injected once.
 */
export function usePlausible() {
  useEffect(() => {
    if (injected) return;
    injected = true;

    // Inline stub so calls before the script loads are queued
    window.plausible = window.plausible || function (...args: unknown[]) {
      (window.plausible.q = window.plausible.q || []).push(args);
    };
    window.plausible.init = window.plausible.init || function (opts?: Record<string, unknown>) {
      window.plausible.o = opts || {};
    };
    window.plausible.init();

    // Load the remote script
    const script = document.createElement('script');
    script.src = 'https://plausible.io/js/pa-5OwZ37a9QqZ6BeDAYVjv1.js';
    script.async = true;
    document.head.appendChild(script);
  }, []);
}
